module.exports = __webpack_public_path__ + "img/133.878b1790.jpg";